'use client'

import { Guarantee } from '@/screens/Guarantee'

import { InfoPageLayout } from '@/shared/lib/layouts/InfoPageLayout'

const GuaranteePageContent = () => {
	return (
		<>
			<InfoPageLayout>
				<Guarantee />
			</InfoPageLayout>
		</>
	)
}

export function GuaranteeClient() {
	return <GuaranteePageContent />
}
